<template>
    <div>
        <tab name="1"></tab>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input class="input-with-select" v-model="params.searchValue" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="群组ID" :value="1"></el-option>
                            <el-option label="群组名称" :value="2"></el-option>
                            <el-option label="演出ID" :value="3"></el-option>
                            <el-option label="演出名称" :value="4"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.sortType" placeholder="请选择" size="small">
                        <el-option label="按照创建时间从新至旧排序" :value="1"></el-option>
                        <el-option label="按照群组人数从多至少排序" :value="2"></el-option>
                        <el-option label="按照群组人数从少至多排序" :value="3"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择" size="small">
                        <el-option label="不限制状态" value=""></el-option>
                        <el-option label="仅看展示的" :value="1"></el-option>
                        <el-option label="仅看隐藏的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
		<div  class="page-btns-box">
		    <el-button type="primary" icon="el-icon-plus" size="small" @click="$refs.ChatGroupAdd.show(dissolveType)" v-if="$utils.have('/group/create')">新建群组</el-button>
		</div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                <el-table-column prop="id" label="群组ID"></el-table-column>
                <el-table-column prop="name" label="群组名称" show-overflow-tooltip min-width="150"></el-table-column>
                <el-table-column prop="memberNum" label="群组人数"></el-table-column>
                <el-table-column prop="activityId" label="演出ID"></el-table-column>
                <el-table-column prop="activityName" label="关联演出" show-overflow-tooltip min-width="150"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" min-width="150"></el-table-column>
                <el-table-column prop="status" label="状态">
                    <template slot-scope="{row} = scope">
                        <el-tag v-if="row.status == 1" size="mini" type="success">展示</el-tag>
                        <el-tag v-else size="mini" type="info">隐藏</el-tag>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="{row} = scope">
                        <el-button v-if="$utils.have('/group/detail') " type="text" size="small" @click="$refs.chatGroupEdit.show(row.id)">管理</el-button>
                        <el-button v-if="$utils.have('/group/disbandmentGroup') && row.status !== 0" type="text" size="small" @click="disbandmentGroup(row)">解散</el-button>
                        <el-button v-if="$utils.have('/group/hide')" type="text" size="small" @click="changeStatus(row)">{{ row.status != 2 ? '隐藏' : '展示' }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0"
            >
            </el-pagination>
        </div>
        <chat-group-edit ref="chatGroupEdit" @onUpdate="getDataList"></chat-group-edit>
		<chat-group-add ref="ChatGroupAdd" @onUpdate="getDataList"></chat-group-add>
    </div>
</template>
<script>
import Tab from './components/tab'
import ChatGroupEdit from './components/edit.vue'
import ChatGroupAdd from './components/add.vue'
const defaultParams = {
    pageNo:1,
    searchType: 1, //查询类型 1：群组id 2：群组名称 3：演出id 4：演出名称
    searchValue: "",
    sortType: 1, //排序类型 1：按照创建时间从新至旧排序(默认排序) 2：按照群组人数从多至少排序 3：按照群组人数从少至多排序
    status: "", //状态 1:有效 0:无效 2：隐藏
}
export default {
    components:{Tab,ChatGroupEdit,ChatGroupAdd},
    data(){
        const _query = this.$route.query;
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: parseInt(_query.pageNo || 1),
                pageSize: parseInt(_query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(_query.searchType || 1),
                searchValue: _query.searchValue || "",
                sortType: parseInt(_query.sortType || 1),
                status: parseInt(_query.status) || "",
            },
            listLoading: true,
			dissolveType:''
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/group/pageList",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
					this.getType()
				} else {
                    this.data = null;
					this.dataList = [];
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
		//新建群组解散时间取 规则里面的时间，所以要在这里调一次接口取里面的时间。12530482
		getType() {
		    this.dataLoading = true;
		    this.$request({
		        url: '/group/configInfo',
		        params: {},
		        method: "post",
		    })
		        .then((res) => {
		            const { state, msg, result } = res.data;
		            if (state && result) {
						this.dissolveType = result.disbandmentTimeType
		            } else {
		                this.$message.error(msg || "请求失败,请重试");
		            }
		        })
		        .catch(() => {
		            this.$message.error("请求失败,请重试");
		        })
		        .finally(() => {
		            this.dataLoading = false;
		        });
		},
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
		//新增事件
		add(){
		    this.$refs.ChatGroupAdd.show();
		},
        //解散
        disbandmentGroup(data){
            const _msg = `<div>当前尝试解散的群组：${data.name}（${data.memberNum}人）</div>\
                        <div class="color-danger">该操作不可逆，是否确认解散？</div>`;
            this.$confirm(_msg, "解散群组", {
                center: true,
                closeOnClickModal: false,
                dangerouslyUseHTMLString: true,
                confirmButtonText: "确认解散",
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: "/group/disbandmentGroup",
                    method: "POST",
                    params: { groupId: data.id },
                })
                    .then((res) => {
                        const { state, msg } = res.data;
                        if (state == 1) {
                            this.getDataList();
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
                    .catch(() => {
                        this.$message.error("请求错误");
                    })
                    .finally(() => {
                        this.listLoading = false;
                    });
            });
        },
        //影藏
        changeStatus(data){
            // const _msg = `${data.status != 2 ? '确定要隐藏吗？' : '确定要展示吗？'}`;
            // this.$confirm(_msg, "提示", {
            //     center: true,
            //     closeOnClickModal: false,
            //     dangerouslyUseHTMLString: true,
            //     confirmButtonText: "确定",
            // }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: "/group/hide",
                    method: "POST",
                    params: { groupId: data.id },
                })
                    .then((res) => {
                        const { state, msg } = res.data;
                        if (state == 1) {
                            this.getDataList();
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
                    .catch(() => {
                        this.$message.error("请求错误");
                    })
                    .finally(() => {
                        this.listLoading = false;
                    });
            // });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>